import { claimCleaner } from "./cleaner";
import { claimContextProvider } from "./context-providers";
import { defaultClaimValidator } from "./validators";

export const testDefaults = {
  contextProvider: claimContextProvider,
  validator:       defaultClaimValidator,
  cleaner:         claimCleaner
}
